import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // ------------------------------------------------------------
  // Scroll listener – adds a small shadow/background when the page
  // is scrolled beyond a threshold.
  // ------------------------------------------------------------
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // ------------------------------------------------------------
  // Helper: scroll smoothly to a section.
  // The original code used a TypeScript type annotation
  // (`sectionId: string`). If this file is processed as plain
  // JavaScript (e.g., .js or .jsx) that annotation throws a
  // syntax error: “Expected identifier but found '/'”.
  // Removing the annotation makes the function valid in both
  // JS and TS environments while keeping full functionality.
  // ------------------------------------------------------------
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (!element) {
      // Graceful fallback – log a warning instead of silently failing.
      console.warn(`Navbar: Section with id "${sectionId}" not found.`);
      return;
    }

    try {
      element.scrollIntoView({ behavior: 'smooth' });
    } catch (err) {
      console.error('Navbar: scrollIntoView failed', err);
    }

    // Close mobile menu after navigation (if open)
    setIsMobileMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-[#14253D]/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-20">
        <div className="flex items-center justify-between h-20 md:h-24">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 md:space-x-4 ml-[-8px]">
            <img
              src="https://static.readdy.ai/image/f9226af7b0c833b6273ae5c168cd92f2/428b66a0cc835ceff325978d7f4a0f99.png"
              alt="VA Jurídico Logo"
              className="h-[70px] md:h-[120px] w-auto"
            />
            <div className="flex flex-col items-center">
              <span className="text-[#B89A5A] text-sm md:text-xl font-serif font-bold tracking-widest whitespace-nowrap">VALENTINA AMIGO</span>
              <span className="text-[#B89A5A] text-[10px] md:text-sm font-serif font-medium tracking-[0.3em] whitespace-nowrap">ABOGADA</span>
            </div>
          </Link>

          {/* Mobile Menu Toggle */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white w-8 h-8 flex items-center justify-center cursor-pointer"
          >
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-[#14253D]/95 backdrop-blur-md border-t border-white/10 py-6 rounded-b-3xl">
            <div className="flex flex-col space-y-4 px-2">
              <button
                onClick={() => scrollToSection('inicio')}
                className="text-white/80 hover:text-[#B89A5A] transition-colors duration-300 text-sm text-left cursor-pointer py-2"
              >
                Inicio
              </button>
              <button
                onClick={() => scrollToSection('servicios')}
                className="text-white/80 hover:text-[#B89A5A] transition-colors duration-300 text-sm text-left cursor-pointer py-2"
              >
                Servicios
              </button>
              <button
                onClick={() => scrollToSection('sobre-mi')}
                className="text-white/80 hover:text-[#B89A5A] transition-colors duration-300 text-sm text-left cursor-pointer py-2"
              >
                Sobre Mí
              </button>
              <button
                onClick={() => scrollToSection('experiencia')}
                className="text-white/80 hover:text-[#B89A5A] transition-colors duration-300 text-sm text-left cursor-pointer py-2"
              >
                Experiencia
              </button>
              <button
                onClick={() => scrollToSection('contacto')}
                className="text-white/80 hover:text-[#B89A5A] transition-colors duration-300 text-sm text-left cursor-pointer py-2"
              >
                Contacto
              </button>
              <button
                onClick={() => scrollToSection('contacto')}
                className="bg-[#B89A5A] text-[#14253D] px-6 py-3 rounded-full text-sm font-semibold hover:bg-[#A68A4A] transition-all duration-300 text-center cursor-pointer whitespace-nowrap mt-2"
              >
                Consulta Gratuita
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
